<div class="title" mat-dialog-title>
    <span class="title-content">Add Bank Account</span>
    <mat-icon class="close" [mat-dialog-close]="true" aria-hidden="false">close</mat-icon>
</div>
<mat-dialog-content>
    <app-bank-account-add
        [borrowerId]="data.borrowerId"
        [showCancel]="(data.bankAccounts$ | async)?.length !== 0"
        (addAccount)="addAccount($event)"
        (cancel)="cancelDialog()"
    ></app-bank-account-add>
</mat-dialog-content>
